import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../shared/services/language.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor(private translate: TranslateService, private languageService: LanguageService,
    @Inject(PLATFORM_ID) private platformID,
    ) {}

  ngOnInit(): void {
    if(isPlatformBrowser(this.platformID)){
      if (localStorage.getItem('language')) {
        this.translate.use(localStorage.getItem('language'))
      }
      this.languageService.languageUpdated.subscribe((lang) => {
        this.translate.use(lang);
      })
    }
  }

}
